export default class Picker {
    constructor(id, element, options) {
        this._id = id;
        this._element = element;
        this._config = {};
        this._options = options;
        this._input = document.querySelector(this._element);
        this.init();
    }
    
    init() {
        this._config = {
            inline: false,
            visible: false,
            autoClose: true,
            toggleSelected: false,
            multipleDatesSeparator: ' - ',
            isMobile: Math.min(document.documentElement.clientWidth, document.documentElement.clientHeight) < 768
        };

        this._config.locale = {
            days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
            daysShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
            daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
            monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            today: 'Heute',
            clear: 'Löschen',
            dateFormat: 'dd.MM.yyyy',
            timeFormat: 'HH:mm',
            firstDay: 1
        };

        this._config.onHide = function(isFinished) {
            if (this._options.range && this._input.picker.selectedDates.length < 2) {
                this.updateDates([this._input.picker.selectedDates[0], this._input.picker.selectedDates[0]]);
            }
            let _event = new CustomEvent('onPickerHide', { detail: { 
                    isFinished: isFinished
                }
            });
            this._input.dispatchEvent(_event);
        }.bind(this);

        this._config.onShow = function(isFinished) {
            let _event = new CustomEvent('onPickerShow', { detail: { 
                    isFinished: isFinished
                }
            });
            this._input.dispatchEvent(_event);
        }.bind(this);

        this._config.onSelect = function({date, formattedDate, datepicker}) {
            let _event = new CustomEvent('onPickerSelect', { detail: { 
                    date: date,
                    formattedDate: formattedDate,
                    datepicker: datepicker
                }
            });
            this._input.dispatchEvent(_event);

            if(this._options.range) {
                this.updateRange(formattedDate);
            }
            
        }.bind(this);

        this.addPosition();

        if (this._options.disabledWeekday) {
            this.disableWeekday();
        }

        this._config = Object.assign(this._config, this._options);

        if (this._config.selectedDates) {
            this._config.startDate = this._config.selectedDates[0];
        }

        this._input.picker = new AirDatepicker(this._element, this._config);

        this._input.addEventListener('change', event => {
            let dates = this._input.value.split(' - ');
            if (this._options.range && dates.length < 2) {
                dates = [dates[0], dates[0]];
            }

            dates.forEach((value, index) => {
                dates[index] = moment(value, 'DD.MM.YYYY', 'de').toDate();
            });

            this._input.picker.selectDate(dates);
        });
    }

    disableWeekday() {
        let disabledDates = this._options.disabledWeekday
        this._config.onRenderCell = function({date}) {
            if (disabledDates.includes(date.getDay())) {
                return {
                    disabled: true
                }
            }
        };
    }

    updateRange(formattedDate) {
        if (formattedDate[0]) {
            let startField = document.querySelector('[name="' + this._options.rangeOptions.startId + '"]');
            if (startField) {
                startField.value = formattedDate[0];
            }
        }
        if (formattedDate[1]) {
            let endField = document.querySelector('[name="' + this._options.rangeOptions.endId + '"]');
            if (endField) {
                endField.value = formattedDate[1];
            }
        }
        this._input.value = formattedDate.join(' - ');
    }

    updateDates(dates, silent = false) {
        this._input.picker.update({
            'selectedDates' : dates
        }, {
            'silent' : silent
        });
    }

    addPosition() {
        this._config.position = function({$datepicker, $target, $pointer, done}) {
            let popper = Popper.createPopper($target, $datepicker, {
                placement: 'top',
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            padding: {
                                top: 64
                            }
                        }
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 20]
                        }
                    },
                    {
                        name: 'arrow',
                        options: {
                            element: $pointer
                        }
                    }
                ]
            });

            return function completeHide() {
                popper.destroy();
                done();
            }
        };
    }
}
